module.exports = __webpack_public_path__ + "media/images/national-aegis-newspaper-0106-1841-red-cross-endicott-winthrop-d328f2460e8c0ea5bf6f3298b3c6656f.png";